// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"727973242bb33abd","3227":"6944b9fc694b9c44"}[chunkId] + ".css";
};